import React, { useState } from "react";
import { Row, Col, Card, Table, Tabs, Tag, Input } from "antd";

const TradesSection = () => {
  const [tab, setTab] = useState("all");

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Instrument",
      dataIndex: "instrument",
    },
    {
      title: "Entry",
      dataIndex: "entry",
    },
    {
      title: "P&L",
      dataIndex: "pnl",
      render: (v) => (
        <span style={{ color: v > 0 ? "#2ecc71" : "#e74c3c" }}>
          ₹{v}
        </span>
      ),
    },
    {
      title: "RR",
      dataIndex: "rr",
    },
  ];

  const data = [
    {
      key: 1,
      date: "Tue, Dec 16 2025",
      instrument: "BankNIFTY",
      entry: "46,200",
      pnl: 1600,
      rr: 2.0,
    },
    {
      key: 2,
      date: "Thu, Jan 8 2026",
      instrument: "NIFTY",
      entry: "23,180",
      pnl: -650,
      rr: -0.7,
    },
  ];

  return (
    <Row gutter={16} style={{ marginTop: 20 }}>
      
      {/* LEFT TABLE */}
      <Col md={14} xs={24}>
        <Card title="Trades">
          
          <Tabs
            defaultActiveKey="all"
            items={[
              { key: "all", label: "All" },
              { key: "wins", label: "Wins" },
              { key: "loss", label: "Losses" },
            ]}
          />

          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            size="small"
          />

        </Card>
      </Col>

      {/* RIGHT SIDE */}
      <Col md={10} xs={24}>
        <Card title="Recent Trades">
          
          {data.map((item) => (
            <div
              key={item.key}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <div>
                <div>{item.instrument}</div>
                <small>{item.date}</small>
              </div>

              <div>
                <div>Entry: {item.entry}</div>
                <div
                  style={{
                    color: item.pnl > 0 ? "#2ecc71" : "#e74c3c",
                  }}
                >
                  ₹{item.pnl}
                </div>
              </div>
            </div>
          ))}

        </Card>
      </Col>

    </Row>
  );
};

export default TradesSection;